'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeHistogram2dIcon = function TraceTypeHistogram2dIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M32 20h6v6h-6zm-12-6h6v6h-6zm-6 6h6v6h-6zm0 12h6v6h-6zm6 0h6v6h-6zm12 0h6v6h-6zm-6-12h6v6h-6z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M26 14h6v6h-6zm6 0h6v6h-6zm-12 6h6v6h-6zM8 20h6v6H8z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M14 14h6v6h-6z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M8 14h6v6H8z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M26 26h6v6h-6zM8 26h6v6H8z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M20 26h6v6h-6zm12 0h6v6h-6zm-18 0h6v6h-6z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M26 8h6v6h-6zM8 8h6v6H8z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M20 8h6v6h-6zm12 0h6v6h-6zM14 8h6v6h-6zM8 32h6v6H8zm18 0h6v6h-6z' }),
        _react2.default.createElement('circle', { cx: '29', cy: '29', r: '2', fill: '#fff' }),
        _react2.default.createElement('circle', { cx: '17', cy: '23', r: '2', fill: '#fff' }),
        _react2.default.createElement('circle', { cx: '17', cy: '35', r: '2', fill: '#fff' }),
        _react2.default.createElement('circle', { cx: '29', cy: '23', r: '2', fill: '#fff' }),
        _react2.default.createElement('circle', { cx: '23', cy: '17', r: '2', fill: '#fff' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#fff', d: 'M29 11l1.5-1.5M29 11l-1.5-1.5M29 11l1.5 1.5M29 11l-1.5 1.5M35 23l1.5-1.5M35 23l-1.5-1.5M35 23l1.5 1.5M35 23l-1.5 1.5M23 35l1.5-1.5M23 35l-1.5-1.5M23 35l1.5 1.5M23 35l-1.5 1.5', strokeLinecap: 'round', strokeLinejoin: 'round' })
    );
};

exports.default = TraceTypeHistogram2dIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeHistogram2dIcon.js
// module id = 713
// module chunks = 0